/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { cache, system } from ".";
import { PublicClientApplication } from "@azure/msal-browser";
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const msalConfig = {
  auth: {
    clientId: "68151760-8f49-4b0a-8375-0b1479f2d8ad",
    authority: "https://login.microsoftonline.com/7370fc8f-4ead-4668-a3a4-ffb467f9374a/",
    redirectUri: process.env.REACT_APP_REDIRECT,
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT + "/",
    navigateToLoginRequestUrl: false,
  },
  cache,
  system,
};

export const adInstance = new PublicClientApplication(msalConfig);
